import { render, staticRenderFns } from "./t-slidegroup.vue?vue&type=template&id=7e08f60a&"
import script from "./t-slidegroup.vue?vue&type=script&lang=js&"
export * from "./t-slidegroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports